import React from 'react'

export default function Header() {
    
   return (
    <nav className="navbar d-flex justify-content-between align-items-center py-3 px-3">
    <p><a className="logo" href="/">Currie</a></p>
    <p><a target='_blank' rel="noreferrer" href="https://bit.ly/3Oco0wQ">Resume <i class="bi bi-download"></i></a></p>
    
</nav>

  )
}
